import { useNavigate } from "react-router-dom";
import { Card, CardDescription, CardTitle } from "../ui/card";
import { Button } from "../ui/button";
import { Lock, ArrowRight } from "lucide-react";

interface NotBootcampProps {
  featureName?: string;
}

export function NotBootcamp({ featureName }: NotBootcampProps) {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-[calc(100vh-4rem)] pt-24 pb-12 px-4 md:px-8">
      <div className="w-full max-w-xl mx-auto my-auto">
        <Card className="flex flex-col justify-center text-center p-8 shadow-lg">
          <div className="mx-auto w-20 h-20 rounded-full bg-muted flex items-center justify-center mb-6">
            <Lock className="w-10 h-10 text-muted-foreground" />
          </div>
          <CardTitle className="text-2xl mb-4">Menu khusus bootcamp</CardTitle>
          <CardDescription className="text-base mb-6">
            {featureName ? `${featureName} hanya tersedia` : "Menu ini hanya tersedia"} untuk user yang sudah mengikuti bootcamp. Join bootcamp untuk membuka aksesnya.
          </CardDescription>
          <Button
            onClick={() => navigate("/bootcamp")}
            size="lg"
            className="w-full h-14 text-sm md:text-base bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white"
          >
            Lihat Info Bootcamp
            <ArrowRight className="w-4 h-4 ml-2" />
          </Button>
        </Card>
      </div>
    </div>
  );
}
